import axios from 'axios';

export const sendResetKeyForgotPassword = async (body) => axios.post(
    `${global?.AppConfig?.CLIENT_URL_SUFFIX}/v1.0/contacts/forgotten-password/send-reset-key?useApplicationToken=true`,
    body,
);

export const getContactInvestmentOverview = async (contactId) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/contacts/${contactId}/investment-overview?language=de`,
);

export const getContactAccounts = ({ clientId }) => axios.get(`${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/contacts/${clientId}/accounts`);
